var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"step-navigation mt24",style:(_setup.fixedStyle)},[_c('el-button',{on:{"click":_setup.backToList}},[_vm._v("\n        返回\n    ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_setup.submitLoading},on:{"click":_setup.submit}},[_vm._v("\n        提交\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }